// extracted by mini-css-extract-plugin
export default {"overlay":"IB-z","bodyOpen":"JB-z","content":"KB-z","header":"LB-z","close":"MB-z","closeNoHeading":"NB-z"};